export default {
  BannerEnabled: 'promotion-banner-enabled',
  BannerClosed: 'promotion-banner-close',
  BannerFilter: 'promotion-banner-filter',
  RefreshMapOptions: 'refresh-google-map-options',
  ListQueryParams: 'promotion-banner-list-query-params',
  QueryParams: 'promotion-query-params',
  List: 'promotion-banner-list',
  ListCollection: 'pormotion-list-collection',
};
